import { get, set, del } from "idb-keyval";

const indexedDBStorage = {
  getItem: async (key) => {
    return await get(key);
  },
  setItem: async (key, value) => {
    return await set(key, value);
  },
  removeItem: async (key) => {
    return await del(key);
  },
};

export default indexedDBStorage;
